import styled from '@rsos/theme/styled';

export const HeaderSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 20px;
`;

export const Wrapper = styled.div`
  padding-top: 20px;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.primaryText};
  display: flex;
  flex-direction: column;
  gap: 10px;
  border-top: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
`;

export const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 150px;
`;

export const FormSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-width: 400px;
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
`;
